import { useAPI } from "react-api-hooks";
import { API_URL } from "../../config/Config";
import _ from "lodash";
import useWindowSize from "../../utils/useWindowSize";
import ErrorLoadingPage from "./../pages/ErrorLoadingPage";
import PageLoader from "../../components/loader/PageLoader";
import Brand from "./Brand";

const BrandHOC = ({ match: { params }, location: { state } }) => {
    const isXl = useWindowSize("xl");
    const { response, error, isLoading } = useAPI(`${API_URL}brand-slag/${params.slag}`);
    if (error) return <ErrorLoadingPage />;
    if (isLoading) return <PageLoader type="spinningBubbles" color="#00b9d7" />;
    const { data, rating, complains, comments } = response.data;

    let { category } = data;
    category = _.orderBy(category, [function (o) { return (o.parent !== null) ? o.id : 0; }], ['asc']);
    return <Brand data={{ ...data, category, state }} from={state} rating={rating} complains={complains} comments={comments} isXl={isXl} />

};

export default BrandHOC;
